import { Col, Row } from "antd";
import { useEffect, useState } from "react";
import "./style.css";
import ParameterCard from "./ParameterCard";
import { executiveStackDataUrl } from "../../Common/endpoints";
import { getApis } from "../../Common/apis";
import { UNITS } from "../../Common/Constants";
import DaysPicker from "../../Common/DaysPicker";
import { useDispatch } from "react-redux";
import { setPageLoader, setPageLastUpdatedTime } from "../../../reducers/loaderSlice";
import dayjs from "dayjs";

const Metrics = ({ data, timeFilter, onTimeChange }) => {
  const dispatch = useDispatch();
  const [stackData, setStackData] = useState(null);
  const authToken = localStorage.getItem("authToken");

  const getStackData = async () => {
    const params = {
      from: timeFilter?.[data]?.[0],
      to: timeFilter?.[data]?.[1],
    };

    await getApis(executiveStackDataUrl, params, authToken)
      .then((response) => {
        setStackData(response?.data);
        dispatch(setPageLoader(null));
        dispatch(setPageLastUpdatedTime(Date.now()));
      })
      .catch((err) => {
        console.log(err);
        dispatch(setPageLoader(null));
        //dispatch(setPageLastUpdatedTime(Date.now()));
        // need not update time as api FAILED

      });
  };

  useEffect(() => {
    if (timeFilter?.[data]?.[0]) {
      getStackData();
    }

    dispatch(setPageLoader("refresh"));
    if (dayjs(timeFilter?.[data]?.[1]) > dayjs().subtract(1, "hour")) {
      const intervalId = setInterval(() => {
        dispatch(setPageLoader("refresh"));
        getStackData();
      }, 5 * 60 * 1000);

      return () => clearInterval(intervalId);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [timeFilter?.[data]]);

  return (
    <>
      <Row justify={"center"}>
        <Col span={24}>
          <div className="flex-center">
            <DaysPicker
              callApis={getStackData}
              timeRange={timeFilter?.[data]}
              onTimeChange={(value) => onTimeChange(data, value)}
              customOptions={["Hour", "Day", "Week", "Month"]}
            />
          </div>
        </Col>
      </Row>

      <ParameterCard stackData={stackData} />

      <div className="section-card mt1">
        <Row gutter={[16, 16]}>
          <Col span={24} className="mt1">
            <div className="pl1">
              <span className="section-head">Battery Temperature </span>
            </div>
          </Col>

          <Col span={24} className="mt1 mb1">
            <Row
              gutter={[16, 24]}
              justify={"space-evenly"}
              className="range-box-row"
            >
              <Col xs={16} sm={10} md={10} lg={10} xl={5} className="range-box">
                <div className="text-center">
                  <span className="range-box-head grey below-text">
                    Below Range
                  </span>
                  <div className="range-box-value mt05">
                    {stackData?.data?.batteryTemp?.belowRange}
                    {UNITS.PERCENT}
                  </div>
                </div>
              </Col>
              <Col xs={16} sm={10} md={10} lg={10} xl={5} className="range-box">
                <div className="text-center">
                  <div className="range-box-head grey">Above Range</div>
                  <div className="range-box-value mt05">
                    {stackData?.data?.batteryTemp?.aboveRange}
                    {UNITS.PERCENT}
                  </div>
                </div>
              </Col>
              <Col xs={16} sm={10} md={10} lg={10} xl={5} className="range-box">
                <div className="text-center">
                  <div className="range-box-head grey">Min</div>
                  <div className="range-box-value mt05">
                    {stackData?.maxMinData?.minBatteryTemp}
                    <span className="mt025 unit ml025">({UNITS.CELSIUS})</span>
                  </div>
                </div>
              </Col>
              <Col xs={16} sm={10} md={10} lg={10} xl={5} className="range-box">
                <div className="text-center">
                  <div className="range-box-head grey">Max</div>
                  <div className="range-box-value mt05">
                    {stackData?.maxMinData?.maxBatteryTemp}
                    <span className="mt025 unit ml025">({UNITS.CELSIUS})</span>
                  </div>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>

      <Row gutter={[16, 16]}>
        <Col xs={24} sm={24} md={12} className="mt1">
          <div className="section-card">
            <Row gutter={[16, 16]} className="pd1">
              <Col span={24}>
                <span className="section-head text-center">Alerts </span>
              </Col>
              <Col
                xs={{ span: 16, offset: 1 }}
                sm={{ span: 10, offset: 1 }}
                md={20}
                lg={{ span: 10, offset: 1 }}
                className="range-box ml1"
              >
                <div className="text-center">
                  <div className="range-box-head grey">Battery</div>
                  <div className=" range-box-value mt05">
                    {stackData?.alertsData?.batteryAlertCount}
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </Col>
      </Row>
    </>
  );
};

export default Metrics;
